var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2 rounded-xl elevation-0",staticStyle:{"background-color":"inherit"},attrs:{"id":"idCard","width":_vm.pWidth,"height":_vm.pHeight}},[_c('Doughnut',{ref:"refChart",attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"color":"transparent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }